module.exports = __webpack_public_path__ + "img/client4.a81fcd7c.png";